import React, { useState } from "react";
import Banner from "../../../../Common_Component/Banner/Banner";
import Breadcrumbs_Holder from "../../../../Common_Component/Breadcrumbs_Holder/Breadcrumbs_Holder";
import Video_Wala_Bus_Stand_content from "./Video_Wala_Bus_Stand_content/Video_Wala_Bus_Stand_content";
import Advantages_Video_Wala_Bus_Stand from "./Advantages_Video_Wala_Bus_Stand/Advantages_Video_Wala_Bus_Stand";
import Why_Stands_Out from "./Why_Stands_Out/Why_Stands_Out";
import Boosts_Your_Business from "./Boosts_Your_Business/Boosts_Your_Business";
import Revolutionizing_Travel from "./Revolutionizing_Travel/Revolutionizing_Travel";
import Why_Choose from "./Why_Choose/Why_Choose";
import Empower_Your_Brand from "./Empower_Your_Brand/Empower_Your_Brand";
import Get_In_Touch from "./Get_In_Touch/Get_In_Touch";
import What_Makes_Us_Different from "./What_Makes_Us_Different/What_Makes_Us_Different";
import InnerBanner from "./InnerBanner/InnerBanner";
import Inquire_Now from "../../../../Home/Inquire_Now/Inquire_Now";
import Counter from "../../../../AboutUs/Counter/Counter";
import AdFlow from "./AdFlow/AdFlow";
import Testimonial from "./Testimonial/Testimonial";

function Video_Wala_Bus_Stand_inner_content() {
  const [data, setData] = useState();
  const breadcrumbs = [
    { label: "Services", link: "/services", active: false },
    {
      label: "Videowala Bus Stand",
      link: "",
      active: true,
    },
  ];
  return (
    <>
      <section className="Video_Wala_Bus_Stand_inner_content">
        <InnerBanner />

        <Breadcrumbs_Holder breadcrumbs={breadcrumbs} data={data} />

        <Video_Wala_Bus_Stand_content />

        <Counter />

        <Advantages_Video_Wala_Bus_Stand />

        <Why_Stands_Out />

        <AdFlow />

        <Boosts_Your_Business />

        <Revolutionizing_Travel />

        <What_Makes_Us_Different />

        <Why_Choose />

        <Empower_Your_Brand />

        <Testimonial/>

        {/* <Get_In_Touch vidowala={true}/> */}
        <Inquire_Now />
      </section>
    </>
  );
}

export default Video_Wala_Bus_Stand_inner_content;
